import {Image} from "@/model/image"
import {computed, Ref, ref, watch} from 'vue'

const galleryImages = ref<Image[]>([])

const columns = computed(() => {
    return window.innerWidth >= 992 ? 4 : 1
})

const galleryColumns = computed(():Image[][]=> {
    if (galleryImages.value.length <= 0) {
        return []
    }
    let idx = 0
    const cols:Image[][] = []
    galleryImages.value.forEach((img:Image) => {
        if (idx >= columns.value) {
            idx = 0
        }
        if (!cols[idx]) {
            cols[idx] = []
        }
        cols[idx].push(img)
        idx++
    })
    return cols
})

const galleryColumn = (idx:number):Ref<Image[]>|undefined => {
    if (idx < 0 || idx >= columns.value) {
        return undefined
    }
    return computed(() => {
        return galleryColumns.value[idx]
    })
}


watch(() => galleryImages.value, () =>{
    console.log(`gallery image change. Length: ${galleryImages.value.length}`)
})

export {
    galleryImages,
    galleryColumn,
    columns as columnAmount
}